import React, { useState, useEffect } from "react";
import ClaimsManagerTable from "pages/ClaimsManager/components/ClaimsManagerTable";
import { Card, CardBody, Container, Row, Col, Label, Button, FormGroup, Input } from 'reactstrap';

import ErrorBoundary from 'components/ErrorBoundary';
import FormikSelectField from "components/common/Fields/FormikSelectField";
import { Field, Formik } from "formik";
import ReactStrapTable from 'components/reactStrapTable';
import useContextService from 'hooks/useContextService';
import { cloneDeep } from "lodash";
import commonColumns from "utils/columns";
import { toast } from 'react-toastify';
import useAxios from 'hooks/useAxios';
import Loader from 'components/Loader';
import Confirm from 'components/Confirm';
import save from "assets/icon/save.svg";



let checkedIds = [];
let allcheckids = [];

const BulkUpdateClaims = (props) => {

    const API = useAxios();

    const {
        states: { claimsManager },
        setStates,
    } = useContextService();


    const { data, statusList, loader, refetchBulkData, search, setBulkUpdate, refetch } = props;

    const { coveredEntity, statusname, } = claimsManager;
    const [toStatusList, setToStatusList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [claimStatusID, setClaimID] = useState('');
    const { coveredEntityID, tenantID } = coveredEntity;
    const [allCheckDefault, setAllCheckDefault] = useState(false);
    const [isConfirm, setConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState('');
    const [validationerror, setValidationError] = useState('');
    useEffect(() => {
        checkedIds = [];
        setToStatusList(statusList);
        setAllCheckDefault(false);
    }, []);

    const handleReason = (e) => {
        setReason(e.target.value.trim())
    }
    const handleAllCheckbox = (e) => {
        setAllCheckDefault(e.target.checked);
        checkedIds = [];

        if (e.target.checked) {
            allcheckids = [];
            if (allcheckids.length === 0) {
                for (var x in data) {
                    allcheckids.push(data[x].claimID);
                    checkedIds.push(data[x].claimID);
                }
                setSelectedIds([...allcheckids]);

            }
        }
        else {
            setSelectedIds([]);
            allcheckids = [];
            checkedIds = [];
        }
    }

    let copycolumns = cloneDeep(commonColumns);
    let columns = [

        {

            text: <Input type="checkbox" title={allcheckids.length == 0 ? "select all" : "unselect all"} onChange={(e) => { handleAllCheckbox(e) }} hidden={data.length == 0} checked={allCheckDefault} />,
            cellRenderer: (rowData) => renderCheckbox(rowData),
            width: 30,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        ...copycolumns


    ];
    const handleSaveConfirmation = () => {
        if (!reason) return setValidationError('Reason is a required field.');
        setConfirm(!isConfirm);
    };
    const handleUpadte = async () => {
        handleSaveConfirmation();
        try {
            setLoading(true);
            const { tenantID, coveredEntityID } = coveredEntity;
            let payload = {};
            payload.CoveredEntityID = coveredEntityID;
            payload.ClaimStatusID = parseInt(claimStatusID);
            payload.Comments = reason;
            payload.ClaimIDs = checkedIds;
            const { data } = await API.post(
                `/${tenantID}/Claim/bulkupdate/${coveredEntityID}`,
                payload
            );
            if (data) {
                refetchBulkData();
                setLoading(false);
                setAllCheckDefault(false);
                toast.success('Claims updated successfully');
                setBulkUpdate(false);
                refetch();
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const handlerChange = (event) => {
        const { value } = event.target;
        if (value) {
            setClaimID(value);
            if (checkedIds.length == 0) {
                checkedIds = [];
                allcheckids = [];
            }
        }
        else {
            setClaimID('');
            if (checkedIds.length == 0) {
                checkedIds = [];
                allcheckids = [];
            }
        }
    };

    let disabled = ((claimStatusID && checkedIds.length > 0) || (claimStatusID && allcheckids.length > 0)) ? false : true;


    const onChange = (claim) => {

        const { claimID, rxNumber, providerID } = claim;
        const index = checkedIds.indexOf(claimID);
        if (checkedIds.length === 0) {
            checkedIds.push(claimID);
        } else {
            if (index >= 0) {
                checkedIds.splice(index, 1);

            } else {
                checkedIds.push(claimID);
            }
        }
        setSelectedIds([...checkedIds]);
    };
    const renderCheckbox = (claim) => {

        const filter = selectedIds.filter((item) => item === claim.claimID);
        return (
            <Input
                onChange={() => onChange(claim)}
                type='checkbox'
                className='me-2 mt-0'
                value={filter.length > 0}
                checked={filter.length > 0}
            />);
    }
    return (

        <div>
            {(loader || loading) && <Loader opacity={0.01} color='black' />}
            <Row>
                <Col md={3}>
                    <FormGroup>
                        <Label>Current Status</Label>
                        <input type="text"
                            className='form-control'
                            name="currentstatus"
                            id='currentstatus'
                            value={statusname}
                            readOnly={true}
                            disabled={true} />

                    </FormGroup>

                </Col>

                <Col md={3}>
                    <FormGroup>
                        <Label>To Status</Label>
                        <Input
                            id="tostatus"
                            name="tostatus"
                            type='select'
                            onChange={(e) => handlerChange(e)}
                        >
                            <option value={''}>--Select--</option>
                            {toStatusList.map((status) => {
                                const { id, description } = status;
                                return (
                                    <option key={id} value={id}>
                                        {description}
                                    </option>
                                );
                            })}


                        </Input>
                    </FormGroup>

                </Col>
                <Col md={3}>
                    <Label>Reason</Label>
                    <Input type="text" onChange={handleReason} name="reason" maxLength={50} autoComplete='off' required />
                    {validationerror && (
                        <div className='text-danger font-size-12' hidden={reason}>
                            {validationerror}
                        </div>
                    )}
                </Col>

                <Col md={3} style={{ paddingTop: '29px' }}>

                    <Button
                        color='primary'
                        onClick={handleSaveConfirmation}
                        disabled={disabled}
                    >
                        <span className="right_5">
                            <img src={save} alt="" />
                        </span>{" "} Update Status
                    </Button>

                </Col>

            </Row>
            <Row>
                <Col md={10}>
                    <Label>Selected Count : {checkedIds.length}</Label>
                </Col>
                <Col md={2}>
                    <Label style={{ paddingLeft: "51PX" }}>Total Count : {data.length}</Label>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>


                        <div
                            // className='table-card filter-table position-relative border-0 '
                            // fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
                            className="table-card scroll-table position-relative border-0 rounded pt-0"
                            fixed-height={data.length > 0 ? "fixed-height" : "default"}
                        >
                            <ReactStrapTable
                                id='bulk-table'
                                columns={columns}
                                data={data}
                                fixedColumn

                            />
                            <Confirm
                                isOpen={isConfirm}
                                loading={loading}
                                message='Are you sure you want to update?'
                                onToggle={handleSaveConfirmation}
                                onCancel={handleSaveConfirmation}
                                onContinue={handleUpadte}

                            />
                        </div>
                    </FormGroup>
                </Col>
            </Row>

        </div>

    );

};
export default BulkUpdateClaims;